import { DataContext } from "../DataContext";
import { useAuth0 } from "@auth0/auth0-react";
import { useContext } from "react";
import { IconLogo } from "../svgs";
import { LoaderStyles } from "../styles";
import { FourDotsLoader } from "./FourDotAnimation";

function Loader(props) {
  const { isLoading, isAuthenticated } = useAuth0();
  const { availableProducts, customer } = useContext(DataContext);

  const shouldLoaderDisplay = () => {
    if (availableProducts.length === 0) {
      return true;
    } else if (isLoading) {
      return true;
    } else if (isAuthenticated && !customer) {
      return true;
    } else {
      return false;
    }
  };

  if (shouldLoaderDisplay()) {
    return (
      <LoaderStyles>
        <IconLogo className="gg-logo" />
        <FourDotsLoader />
      </LoaderStyles>
    );
  } else {
    return <>{props.children}</>;
  }
}

export default Loader;
